import * as React from "react";

// SPARK currency glyph — a solid (filled) lightning bolt. web-backoffice
// has no icon library, so this inlines lucide's `zap` shape (filled) to
// match web-client's <Spark> without pulling in lucide-react.
export function Spark({
  className,
  style,
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
      className={className}
      style={style}
      aria-hidden
      {...rest}
    >
      <path d="M13 2 L3 14 L12 14 L11 22 L21 10 L12 10 Z" />
    </svg>
  );
}
